import { FormGroupTheme } from '@kite-js/theme-types';

const formGroup: FormGroupTheme = {
    childMarginX: 'NONE',
    childMarginY: 'XS',
};

export default formGroup;
